// extracted by mini-css-extract-plugin
module.exports = {"label":"_93444fe79c--label--3Naw9","button":"_93444fe79c--button--1PtdC","button-new":"_93444fe79c--button-new--13w2H"};